<template>
  <stage-card-info-list>
    <template #header>{{ title }}</template>
    <template #content>
      <bubble-info-list-item
        v-for="task in tasks"
        :key="task.key"
        :bubble-text="task.count.toLocaleString()"
      >
        {{ task.text }}
      </bubble-info-list-item>
      <stage-card-info-list-item v-if="tasks.length === 0">
        No further actions required.
      </stage-card-info-list-item>
    </template>
  </stage-card-info-list>
</template>

<script>
import StageCardInfoList from './StageCardInfoList';
import StageCardInfoListItem from './StageCardInfoListItem';
import BubbleInfoListItem from './BubbleInfoListItem';

export default {
  name: 'RemainingTasksList',
  components: {
    StageCardInfoList,
    StageCardInfoListItem,
    BubbleInfoListItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    tasks: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
